<template>
    <div>
        <div class="card-container inline-block full-width">
            <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
            <div class="row-header">
                <div class="row-header-item left">Username</div>
                <div class="row-header-item middle">Email</div>
                <div class="row-header-item right"></div>
            </div>
            <div class="account-container">
                <admin-account-row v-for="admin in adminAccounts" :key="admin.id" :adminAccount="admin"></admin-account-row>
            </div>
            <router-link class="button is-text text-blue" :to="{name: 'adminAccountInvitation'}">Invite Additional Admin Users</router-link>
        </div>
    </div>
</template>

<script>
import store from '../store.js'
import userAPI from '@/api/UserAPI.js'
import AdminAccountsTable from '@/components/AdminAccountsTable'
import AdminAccountRow from '@/components/AdminAccountRow'
import { mapState } from 'vuex'

export default {

    components:{
        'admin-accounts-table' : AdminAccountsTable,
        'admin-account-row' : AdminAccountRow
    },

    data(){
        return{
            adminAccounts:[],
            isLoading: false,
            isFullPage: true,
        }
    },

    created(){
        this.queryAdminAccounts();
    },

    computed: {

        ...mapState([
            'userInfo'
        ])
    },

    methods:{
        /**
         * LOADS ALL ADMIN ACCOUNTS
         */
        queryAdminAccounts: async function(){
            this.isLoading = true;
            var adminAccountsArray = [];
            var accountID = this.userInfo.accountID;

            try{
                var results = await userAPI.loadAdminAccounts(accountID);
                var response = results.response;

                if(response == undefined){
                    this.isLoading = false;
                    return
                }

                //FORMAT ARRAY OF INFORMATION
                response.data.forEach(value =>{
                    var adminAccountObject = {
                        id: value.fieldData.__kptID, 
                        userEmail: value.fieldData.userEmail, 
                        username: value.fieldData.username,
                    }

                    adminAccountsArray.push(adminAccountObject);
                })

                this.adminAccounts = adminAccountsArray;
                this.isLoading = false;
            }
            catch(e){
                if(e.message != undefined){
                    this.$snotify.error( e.message , "Error",
                        {
                            showProgressBar: false,
                            position: 'rightBottom',
                            icon: false,
                            timeout: this.notificationDuration,
                            closeOnClick: true,
                            bodyMaxLength: 1000
                        }
                    )
                }
                else {
                    this.$snotify.error( "Could not retrieve list of admin accounts" , "Error",
                        {
                            showProgressBar: false,
                            position: 'rightBottom',
                            icon: false,
                            timeout: this.notificationDuration,
                            closeOnClick: true,
                            bodyMaxLength: 1000
                        }
                    ) 
                }
            }
        }
    }
}
</script>

<style scoped>
    .is-active-text{
        color: #000000;
        text-decoration: underline overline;
    }

    .is-nav-item{
        color: #000000;
    }

    .is-nav-item:hover{
        color: #A9A9A9;
        text-decoration: underline overline;
    }

    .nav-divider{
        display: inline-block;
        width: 50%;
        
    }

    .row-header{
        font-weight: 600;
        color: #363636;
        font-size: 1em;
        line-height: 1.5;
        width: 100%;
        padding: 8px 0px;
        border-bottom: 2px solid #DBDBDB;
    }

    .dropdown{
        border:none;
        background-color: transparent;
    }

    .row-header-item{
        display: inline-block;
        width: 50%;
        padding-left: 12px
    }

    .account-container{
        max-height: 500px;
        overflow: auto;
    }

    .left{
        width: 40%
    }

    .middle{
        width: 45%
    }

    .right{
        width: 15%
    }
    
    .text-blue{
        color: #3366BB;
    }

    @media screen and (max-width: 811px){
        .row-header{
            display: none
        }
    }
</style>